<template>
  <div
    v-click-outside="{
      callback: unsetActivePageOption,
      blurSelectors: '.frameLfp,.selected'
    }"
    class="frameLfp"
  >
    <div class="popupTitle">
      <span>{{ propsData.popup_title }}</span>
      <a class="closePopup" @click="unsetActivePageOption">x</a>
    </div>
    <ul class="frameList">
      <li
        v-for="option in getOptions"
        :key="option.id"
        :class="{ hasThumbnail: imageSrc(option.id), option }"
        @click="changePageoption($event, option.id)"
      >
        <div
          :class="{ imageOptionImage: 1, noImage: !imageSrc(option.id) }"
          :style="{ backgroundImage: 'url(' + imageSrc(option.id) + ')' }"
        >
          <div class="checkBorder">
            <div v-if="checkIfSelected(option)" class="checked"></div>
          </div>
        </div>
        <span class="title"> {{ option.text }} </span>
        <div v-if="getDescription(option.id)" class="description">
          <small>{{ getDescription(option.id) }}</small>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { useActiveOptionStore } from "@/stores/modules/activeOption";
import * as R from "ramda";
export default {
  computed: {
    ...mapState(useWebproductStore, [
      "getActiveProductPageOptions",
      "getProductPageOptionsForCode"
    ]),
    name: () => {
      return "Information";
    },
    getOptions: function () {
      return R.filter(function (option) {
        return option.id.split("custom_").length == 1;
      }, this.propsData.values);
    },
    getCode: function () {
      return this.propsData.code;
    },
    getSelected: function () {
      if (this.propsData.selected) {
        return this.propsData.selected[0];
      }
      return "";
    },
    isBookbinding: function () {
      if (this.propsData.code == "book_bind") return true;
      return false;
    }
  },
  methods: {
    ...mapActions(useChangeOptionsStore, ["setPageOption"]),
    ...mapActions(useActiveOptionStore, ["setActivePageOptionCode"]),
    imageSrc: function (pageOption) {
      var pageOptionsValues = [];
      if (this.getActiveProductPageOptions[this.propsData.code]) {
        pageOptionsValues =
          this.getActiveProductPageOptions[this.propsData.code].values;
      }
      if (pageOptionsValues.length) {
        var attr = R.filter(function (item) {
          if (item.value == pageOption) {
            return true;
          }
        }, pageOptionsValues);
        if (attr.length) {
          return attr[0].image;
        }
      }
      return null;
    },
    checkIfSelected: function (option) {
      var selected = "";
      if (this.propsData.selected) {
        selected = this.propsData.selected[0];
      }

      return option.id == selected;
    },

    getDescription: function (pageOption) {
      var pageOptionsValues = [];
      if (this.getActiveProductPageOptions[this.propsData.code]) {
        pageOptionsValues =
          this.getActiveProductPageOptions[this.propsData.code].values;
      }
      if (pageOptionsValues.length) {
        var attr = R.filter(function (item) {
          if (item.value == pageOption) {
            return true;
          }
        }, pageOptionsValues);

        if (attr.length) {
          if (attr[0]["attributes"].description_frame)
            return attr[0]["attributes"].description_frame;
        }
      }
      return null;
    },
    unsetActivePageOption: function (event) {
      event.preventDefault();
      this.setActivePageOptionCode("");
    },
    changePageoption: function (event, newValue) {
      this.setPageOption({
        value: newValue,
        layout: false,
        option: this.propsData.code,
        optionType: "main"
      });
      return false;
    }
  },
  props: ["propsData", "optionType", "selectId"]
};
</script>
